import { Metadata } from "./metadata"

export interface NominalCodeMpet extends Metadata {
    type: string,
}

export const NominalCodeTypes = [
    { description: 'Sales' },
    { description: 'Purchase' },
]